import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Building2, PieChart, Wrench, TrendingUp, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

const icons = [Building2, PieChart, Wrench, TrendingUp];
const reds = [false, true, false, true];

export const SinovarWay = () => {
  const { t } = useLang();
  return (
    <section data-testid="sinovar-way-section" className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <span className="text-xs font-bold uppercase tracking-[0.16em] text-sinovar-red">{t.way.kicker}</span>
        <Reveal delay={0.05}>
          <h2 className="mt-3 font-display text-4xl md:text-[3.2rem] font-bold tracking-tight text-sinovar-navy leading-[1.05]">
            {t.way.title}
          </h2>
        </Reveal>
        <p className="mt-5 max-w-2xl text-lg text-sinovar-navy/60 leading-relaxed">{t.way.sub}</p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.way.items.map((item, i) => {
            const Icon = icons[i];
            const red = reds[i];
            return (
              <motion.div
                key={i}
                data-testid={`way-item-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.07, ease: [0.16, 1, 0.3, 1] }}
                className="rounded-2xl border border-black/[0.07] bg-white p-6 hover:shadow-lg hover:shadow-sinovar-navy/5 transition-shadow"
              >
                <Icon className={`h-8 w-8 ${red ? "text-sinovar-red" : "text-sinovar-blue"}`} strokeWidth={1.6} />
                <div className="mt-5 font-display text-base font-bold tracking-tight text-sinovar-navy leading-snug">
                  {String(i + 1).padStart(2, "0")}. {item.name}
                </div>
                <p className="mt-3 text-sm text-sinovar-navy/55 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <Link
          to="/about"
          data-testid="way-cta"
          className="group mt-10 inline-flex items-center gap-2 text-[15px] font-semibold text-sinovar-blue"
        >
          {t.way.cta}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </section>
  );
};
